import React from 'react'
import { DateRangePicker, DateRangePickerProps } from '@mui/x-date-pickers-pro'

export const calendarRowTextFieldStyles = (direction: 'left' | 'right') => ({
  '& .MuiOutlinedInput-root': {
    fontSize: '12px',
    borderTopRightRadius: direction === 'right' ? '0' : '4px',
    borderBottomRightRadius: direction === 'right' ? '0' : '4px',
    borderTopLeftRadius: direction === 'right' ? '4px' : '0',
    borderBottomLeftRadius: direction === 'right' ? '4px' : '0',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRight: direction === 'right' ? 'none !important' : '',
      borderLeft: direction === 'left' ? 'none !important' : '',
      top: '0 !important',
      '& *': {
        display: 'none'
      }
    }
  },
  '& .MuiInputLabel-root': {
    display: 'none'
  }
})

const CustomDateRangePicker = <T extends any>(
  props: DateRangePickerProps<T>
) => {
  return <DateRangePicker {...(props as any)} />
}
export default CustomDateRangePicker
